!function() {
  class t extends HTMLElement {
    constructor() {
      super(), this.filledIcon = this.getAttribute("data-filled-icon"), this.productId = this.getAttribute("data-product-id"), 
      this.variantId = this.getAttribute("data-variant-id"), this.isFavorited = !1, this.clickListenerAttached = !1;
    }
    connectedCallback() {
      window.SwymCallbacks ??= [], window.SwymCallbacks.push(() => this.initSwym());
    }
    initSwym() {
      this && "undefined" != typeof _swat && _swat.fetchWrtEventTypeET(t => this.checkWishlistStatus(t), 4);
    }
    checkWishlistStatus(t) {
      this.originalHTML = this.originalHTML || this.innerHTML;
      if (t.some(t => String(t.empi) === String(this.productId) && String(t.epi) === String(this.variantId)) ? this.setFavoritedState() : this.setUnfavoritedState(), 
      !this.clickListenerAttached) {
        (this.closest("button") ?? this).addEventListener("click", t => {
          t.preventDefault(), t.stopPropagation(), this.isFavorited ? this.removeFromWishlist() : this.addToWishlist();
        }), this.clickListenerAttached = !0;
      }
    }
    addToWishlist() {
      if ("undefined" != typeof _swat) {
        const t = {
          empi: Number(this.productId),
          epi: Number(this.variantId),
          et: 4
        };
        _swat.addToWishList(t, () => {
          this.setFavoritedState();
        }, t => {
          console.error("[WishlistButton] Failed to add to wishlist:", t);
        });
      }
    }
    removeFromWishlist() {
      if ("undefined" != typeof _swat) {
        const t = {
          empi: Number(this.productId),
          epi: Number(this.variantId),
          et: 4
        };
        _swat.removeFromWishList(t, () => {
          this.setUnfavoritedState();
        }, t => {
          console.error("[WishlistButton] Failed to remove from wishlist:", t);
        });
      }
    }
    setFavoritedState() {
      this.isFavorited = !0, this.innerHTML = this.filledIcon;
      const t = this.closest("button");
      if (t) {
        const i = this.getAttribute("data-label-remove") || "Remove from wishlist";
        t.setAttribute("aria-label", i);
      }
    }
    setUnfavoritedState() {
      this.isFavorited = !1, this.originalHTML && (this.innerHTML = this.originalHTML);
      const t = this.closest("button");
      if (t) {
        const i = this.getAttribute("data-label-add") || "Add to wishlist";
        t.setAttribute("aria-label", i);
      }
    }
  }
  customElements.get("wishlist-button") || customElements.define("wishlist-button", t);
}();